var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-charts-page"},[_c('div',{ref:"customCo",staticClass:"charts"})])
}
var staticRenderFns = []

export { render, staticRenderFns }